<dx-scroll-view>
  <div class="grid p-4 grid-cols-12 gap-4">
    <div class="col-span-4">
<!--      <app-dashboard-section name="Temps Réel" gridClass="grid grid-cols-1 gap-3">
        <app-dashboard-widget>
          <app-fields-interventions-realtime-list></app-fields-interventions-realtime-list>
        </app-dashboard-widget>
      </app-dashboard-section>-->
    </div>
    <div class="col-span-8">

      <app-dashboard-section [toolbar]="dashboardTimeToolbar" name="Graphs" gridClass="grid grid-cols-8 gap-3">
        <app-dashboard-widget [cols]="8" [rows]="2">
          <app-fields-intervention-time-widget [dataSource]="dashboardData?.metrics"></app-fields-intervention-time-widget>
        </app-dashboard-widget>
      </app-dashboard-section>
    </div>
  </div>
</dx-scroll-view>
